import { render, staticRenderFns } from "./VariacoesLista.vue?vue&type=template&id=95856ee6&scoped=true&"
import script from "./VariacoesLista.vue?vue&type=script&lang=js&"
export * from "./VariacoesLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95856ee6",
  null
  
)

export default component.exports